import { Farmer, ServiceType } from "@agroyaar/sdk";
import { joinBaseURLWithPath } from "../../../../../utils/joinBaseURLWithPath";
import { useImgBase64 } from "../../../hooks/useImgBase64";
import { reportColor } from "../../../utils/report-color";

interface FarmerInformationProps {
  farmer: Farmer;
  serviceType: ServiceType;
}

const FarmerInformation = ({ farmer, serviceType }: FarmerInformationProps) => {
  const colorCode = reportColor(serviceType);

  const [img] = useImgBase64(joinBaseURLWithPath(farmer.avatar));

  return (
    <div className="flex flex-col justify-center items-start w-1/2 gap-2">
      <span className="font-bold text-[20px] text-[#222] !font-[B-Nazanin]">
        اطلاعات کشاورز
      </span>

      <div className="flex flex-row justify-start items-center gap-[19px] w-full">
        <img
          src={img}
          alt={farmer.firstName}
          width={70}
          height={70}
          className="rounded-full"
          style={{ border: `2px solid ${colorCode}` }}
        />
        <div className="flex flex-col justify-center items-start gap-[6px] ">
          <span className="font-bold text-[18px] !font-[B-Nazanin]">
            {farmer.firstName} {farmer.lastName}
          </span>

          <div className="flex flex-row items-start gap-[8px]">
            <span className="font-bold text-[18px] !font-[B-Nazanin]">
              کد کشاورزی:
            </span>
            <span className="font-bold text-[16px] !font-[B-Nazanin]">
              {farmer.farmerCode}
            </span>
          </div>

          <div className="flex flex-row items-start gap-[8px]">
            <span className="font-bold text-[18px] !font-[B-Nazanin]">
              استان و شهر:
            </span>
            <span className="font-bold text-[16px] !font-[B-Nazanin]">
              {farmer.province.name}، {farmer.city.name}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FarmerInformation;
